import { PluginHistory } from "@api/apiClient";
import { usePluginsHistory } from "@api/designAutomations";
import DataGrid from "@components/DataGrid/DataGrid";
import i18n from "@i18n/i18n";
import { Box } from "@mui/material";
import { GridColDef, useGridApiRef } from "@mui/x-data-grid-premium";
import { observer } from "mobx-react";
import { useEffect, useRef, useState } from "react";

const DesignAutomationGrid = observer(() => {
  const [rows, setRows] = useState<PluginHistory[]>([]);
  const apiRef = useGridApiRef();
  const containerRef = useRef(null);
  const pluginHistory = usePluginsHistory();

  useEffect(() => {
    setRows(pluginHistory.data ?? []);
  }, [pluginHistory.data]);

  const columns: GridColDef[] = [
    {
      field: "daPluginsHistoryId",
      headerName: i18n.t("design-automation.grid.columns.id"),
      editable: false,
      width: 50,
    },
    {
      field: "fileName",
      headerName: i18n.t("design-automation.grid.columns.filename"),
      editable: false,
      flex: 1,
      minWidth: 400,
    },
    {
      field: "version",
      headerName: i18n.t("design-automation.grid.columns.version"),
      editable: false,
      flex: 1,
      minWidth: 100,
    },
    {
      field: "activityName",
      headerName: i18n.t("design-automation.grid.columns.activity-name"),
      editable: false,
      flex: 1,
      minWidth: 200,
    },
    {
      field: "engine",
      headerName: i18n.t("design-automation.grid.columns.engine"),
      editable: false,
      flex: 1,
      minWidth: 200,
    },
    {
      field: "description",
      headerName: i18n.t("design-automation.grid.columns.description"),
      editable: false,
      flex: 1,
      minWidth: 400,
    },
    {
      field: "status",
      headerName: i18n.t("design-automation.grid.columns.status"),
      editable: false,
      flex: 1,
      minWidth: 200,
    },
    {
      field: "message",
      headerName: i18n.t("design-automation.grid.columns.message"),
      editable: false,
      flex: 1,
      minWidth: 400,
    },
    {
      field: "createdAt",
      headerName: i18n.t("design-automation.grid.columns.create-date"),
      editable: false,
      flex: 1,
      minWidth: 200,
      renderCell: (params: any) => {
        return i18n.t("datetime_short", { value: new Date(params.row.createdAt) });
      },
    },
  ];

  return (
    <Box ref={containerRef} sx={{ width: "100%", height: "100%" }}>
      <DataGrid apiRef={apiRef} loading={pluginHistory.isFetching} columns={columns} rows={rows} getRowId={(row) => row.daPluginsHistoryId} hideFooter={false} autoHeight />
    </Box>
  );
});

export default DesignAutomationGrid;
